import { WatermarkTemplates } from "./watermark-templates";

export class UpdateShareRequest {
  shareId: number | null = 0;
  maxDays: number | null = 0;
  maxViews: number | null = 0;
  maxIPs: number | null = 0;
  maxClipsNumber: number | null = 0;
  maxClipsDuration: string | null = null;
  watermarkTemplate: WatermarkTemplates | null = null;
  watermarkText: string | null = null;

  constructor(init?: Partial<UpdateShareRequest>) {
    Object.assign(this, init);
  }
}
